import { ErrorMessage } from '@hookform/error-message'
import { DownArrow, StarIcon, UpArrowIcon } from 'assets'
import { CustomModal } from 'components'
import { errorMessage } from 'constant/const'
import { useOutsideClick } from 'Hooks'
import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import axiosInstance from 'utils/axiosConfig'
import { convertObjectToFormData } from 'utils/convertFormData'
import { toastError } from 'utils/toastify'

const feedbackOpt = [
   {
      label: 'Product Quality',
      value: 'Product Quality'
   },
   {
      label: 'Customer Service Experience',
      value: 'Customer Service Experience'
   },
   {
      label: 'Suggestions for Improvement',
      value: 'Suggestions for Improvement'
   },
   {
      label: 'Technical Issues',
      value: 'Technical Issues'
   },
   {
      label: 'Pricing and Offers',
      value: 'Pricing and Offers'
   },
   {
      label: 'Other (Specify)',
      value: 'Other (Specify)'
   }
]

function FeedBackModal({ show, onClose }) {
   const [rating, setRating] = useState(0)
   const [openFeedBackType, setOpenFeedBackType] = useState(false)
   const topicRef = useOutsideClick(() => setOpenFeedBackType(false))
   const [selectedType, setSelectedType] = useState('')
   const [charCount, setCharCount] = useState(0)
   const [loading, setLoading] = useState(false)
   const {
      setValue,
      handleSubmit,
      formState: { errors },
      register
   } = useForm()

   register('rating', { required: { message: 'Rating is required', value: true } })

   const handleRating = (index) => {
      setRating(index + 1)
      setValue('rating', index + 1, { shouldValidate: true })
   }

   const onChangesTopicType = (type) => {
      setSelectedType(type)
      setOpenFeedBackType(false)
   }

   const onSubmit = (data) => {
      console.log(data)
      let formData = convertObjectToFormData(data)
      !loading && onSaveFeedBackData(formData)
   }

   const onSaveFeedBackData = async (data) => {
      try {
         setLoading(true)
         const response = await axiosInstance.post(`/user/feedback/add/`, data)
         console.log(response.status)
         if (response.status == 200) {
            onClose()
         }
         setLoading(false)
      } catch (error) {
         setLoading(false)
         toastError(errorMessage)
         console.log('error')
         throw error.response ? error.response?.data?.message : error?.message
      }
   }

   const handleTextChange = (event) => {
      const text = event.target.value
      setCharCount(text.length)
      setValue('message', text)
   }

   return (
      <div>
         <CustomModal
            show={show}
            title={'Share Feedback'}
            closeModal={onClose}
            centered
            footerComponent={
               <>
                  <div className="feedback-btn-group">
                     <button className={`atenya-ai-btn `}>
                        <span className="content-text">Contact Us</span>
                     </button>
                     <Button
                        className="at-auth-btn w-100"
                        disabled={loading}
                        onClick={handleSubmit(onSubmit)}>
                        {loading ? 'Adding...' : 'Share Feedback'}
                     </Button>
                  </div>
               </>
            }>
            <div>
               <p className="at-text-light hading-feedback">
                  We value your input! Let us know how we can enhance your experience or suggest
                  improvements for the platform. Your feedback helps us grow and serve you better.
               </p>
               <div className="feedback-start-wrap">
                  {[...Array(5)].map((_, index) => (
                     <StarIcon
                        key={index}
                        className={`feedback-start ${index < rating ? 'selected' : ''}`}
                        onClick={() => handleRating(index)}
                     />
                  ))}
               </div>
               {errors?.rating && (
                  <span className="error-text mt-2 d-inline-block">
                     <ErrorMessage
                        errors={errors}
                        name="rating"
                        message={errors?.rating?.message}
                     />
                  </span>
               )}
               <div className="feed-back-input mt-4 mb-2">
                  <div className="at-dropdown-filer-wrap" ref={topicRef}>
                     <label className="at-text-light mb-2 label-feedback">Topic</label>
                     <div
                        className="at-dropdown-filer"
                        onClick={() => {
                           setOpenFeedBackType(!openFeedBackType)
                        }}>
                        <span className="at-text-light">
                           {selectedType ? selectedType : 'Select Topic'}{' '}
                        </span>
                        {openFeedBackType ? <UpArrowIcon /> : <DownArrow />}
                     </div>
                     {openFeedBackType && (
                        <ul className="at-list-opt">
                           {feedbackOpt &&
                              feedbackOpt?.map((item, i) => {
                                 return (
                                    <li
                                       onClick={() => {
                                          onChangesTopicType(item.value)
                                          setValue('topic', item.value)
                                       }}>
                                       <div className="at-list-wrap" key={i}>
                                          <span className="at-opt-name at-text-dark">
                                             {item?.label}
                                          </span>
                                          <span
                                             className={`at-opt-pin ${
                                                selectedType === item?.value
                                                   ? 'active'
                                                   : ''
                                             }`}>
                                             {/* active */}
                                             <span className="w-dot"></span>
                                          </span>
                                       </div>
                                    </li>
                                 )
                              })}
                        </ul>
                     )}
                  </div>
               </div>
               <div className="">
                  <div className="label-text-wrap">
                     <label className="at-text-light mb-2 label-feedback">
                        Share your thought{' '}
                     </label>
                     <span className="at-text-light label-feedback">{charCount}/500</span>
                  </div>
                  <textarea
                     className="form-control feedback-textarea"
                     placeholder="Description..."
                     rows={4}
                     maxLength={500}
                     onChange={handleTextChange}></textarea>
               </div>
            </div>
         </CustomModal>
      </div>
   )
}

export default FeedBackModal
